import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
import { Box, Typography, Container, Grid } from "@mui/material";
import { getImageUrl } from "api/ImageViewer";
import { getWebsite } from "api/configWebsiteAPI";
// import SampleLogo from "assets/images/logos/LogoZumi.png";

function FooterCustom() {
  // const isMobile = useMediaQuery("(max-width:600px)");
  const [chinhSachLinks, setChinhSachLinks] = useState([]);
  const [sanPhamLinks, setSanPhamLinks] = useState([]);
  const [workingHours, setWorkingHours] = useState([]);
  const typographyStyle = {
    fontSize: "14px",
    lineHeight: 1.5,
    mb: 0.5,
  };
  const [companyInfo, setCompanyInfo] = useState({
    name: "",
    address: "",
    phone: "",
    factory: "",
    email: "",
    gpkd: "",
  });
  const [logoZumi, setLogoZumi] = useState("");
  function resolvePreviewSrc(logo) {
    if (!logo) return "";
    if (typeof logo === "string") {
      return logo.startsWith("data:image") ? logo : getImageUrl(logo);
    }
    if (logo instanceof File) {
      return URL.createObjectURL(logo);
    }
    return "";
  }
  async function fetchConfig() {
    const data = await getWebsite();
    if (data) {
      try {
        const parsedFooter = JSON.parse(data.footer);
        setCompanyInfo(parsedFooter.companyInfo || {});
        setChinhSachLinks(parsedFooter.chinhSach || []);
        setSanPhamLinks(parsedFooter.products || []);
        setWorkingHours(parsedFooter.workingHours || []);

        const parsedHeader = JSON.parse(data.header);
        setLogoZumi(resolvePreviewSrc(parsedHeader?.logo));
      } catch (err) {
        console.error("Lỗi parse JSON:", err);
      }
    }
  }
  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#e5f3fc",
          color: "#000",
          py: 6,
          borderTop: "3px solid #134061", // thêm viền trên
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={2} justifyContent="center">
            {/* Cột 1: Logo + thông tin công ty */}
            <Grid item xs={12} md={4}>
              <Box mb={2}>
                <Box
                  component="a"
                  href={logoZumi}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "inline-block",
                    transition: "filter 0.3s ease, transform 0.3s ease",
                    "&:hover, &:focus": {
                      filter: "brightness(1.2)", // sáng hơn 20%
                      transform: "scale(1.03)", // phóng nhẹ lên
                    },
                  }}
                >
                  <Box component="img" src={logoZumi} alt="Zumi Logo" sx={{ width: 175, mb: 2 }} />
                </Box>
              </Box>
              <Typography sx={{ ...typographyStyle, mb: 1.4 }}>
                <strong>Công ty:</strong> {companyInfo.name}
              </Typography>
              <Typography sx={{ ...typographyStyle, mb: 1.4 }}>
                <strong>Địa chỉ:</strong> {companyInfo.address}
              </Typography>
              <Typography sx={{ ...typographyStyle, mb: 1.4 }}>
                <strong>Số điện thoại:</strong>{" "}
                <a
                  href={`tel:${companyInfo.phone}`}
                  style={{ color: "#e53935", textDecoration: "none" }}
                >
                  {companyInfo.phone}
                </a>
              </Typography>
              <Typography sx={{ ...typographyStyle, mb: 1.4 }}>
                <strong>Xưởng:</strong> {companyInfo.factory}
              </Typography>
              <Typography sx={{ ...typographyStyle, mb: 1.4 }}>
                <strong>Email:</strong> {companyInfo.email}
              </Typography>
              <Typography sx={{ ...typographyStyle, mt: 1.4 }}>{companyInfo.gpkd}</Typography>
            </Grid>

            {/* Cột 2: Chính sách */}
            <Grid item xs={6} sm={6} md={2}>
              <Typography
                component="a"
                href="https://zumi.com.vn/tin-tuc"
                target="_blank"
                rel="noopener noreferrer"
                variant="h6"
                sx={{
                  mb: 2,
                  fontSize: "16px",
                  display: "inline-block",
                  color: "#006",
                  textDecoration: "none",
                  transition: "filter 0.3s ease, transform 0.3s ease",
                  "&:hover, &:focus": {
                    filter: "brightness(1.2)",
                    transform: "scale(1.03)",
                    textDecoration: "none",
                  },
                }}
              >
                CHÍNH SÁCH
              </Typography>

              {chinhSachLinks.map((item) => (
                <Typography
                  key={item.href}
                  component="a"
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    ...typographyStyle,
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                    transition: "filter 0.2s ease",
                    "&:hover": {
                      filter: "brightness(1.3)",
                    },
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Grid>

            {/* Cột 3: Sản phẩm */}
            <Grid item xs={6} sm={6} md={2}>
              <Typography
                component="a"
                href="https://zumi.com.vn/san-pham"
                target="_blank"
                rel="noopener noreferrer"
                variant="h6"
                sx={{
                  mb: 2,
                  fontSize: "16px",
                  display: "inline-block",
                  color: "#006",
                  textDecoration: "none",
                  transition: "filter 0.3s ease, transform 0.3s ease",
                  "&:hover, &:focus": {
                    filter: "brightness(1.2)",
                    transform: "scale(1.03)",
                    textDecoration: "none",
                  },
                }}
              >
                SẢN PHẨM
              </Typography>

              {sanPhamLinks.map((item) => (
                <Typography
                  key={item.href}
                  component="a"
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    ...typographyStyle,
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                    transition: "filter 0.2s ease",
                    "&:hover": {
                      filter: "brightness(1.3)",
                    },
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Grid>

            {/* Cột 4: Bộ Công Thương + thời gian */}
            <Grid item xs={12} md={2}>
              <Box mb={0}>
                <Box
                  component="a"
                  href="http://online.gov.vn/Home/WebDetails/108602"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "inline-block",
                    transition: "filter 0.3s ease, transform 0.3s ease",
                    "&:hover, &:focus": {
                      filter: "brightness(1.2)",
                      transform: "scale(1.03)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src="/images/bo-cong-thuong.png"
                    alt="Bộ Công Thương"
                    sx={{ width: 140 }}
                  />
                </Box>
              </Box>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px", mb: 1 }}>
                Thời gian hoạt động
              </Typography>
              {workingHours.map((line, idx) => (
                <Typography key={idx} sx={typographyStyle}>
                  {line}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box
        sx={{
          backgroundColor: "#134061",
          color: "#FFFFFF",
          textAlign: "center",
          paddingTop: "15px",
          paddingBottom: "15px",
        }}
      >
        <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "400" }}>
          Copyright © 2025 zumi.com.vn - Giải pháp nâng tầm giá trị thương hiệu
        </Typography>
      </Box>
    </>
  );
}
export default FooterCustom;
